import { render } from "./address-group.vue?vue&type=template&id=1601c643"
import script from "./address-group.vue?vue&type=script&lang=js"
export * from "./address-group.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__